import $ from 'jquery';
import Ajax from '../../../../utils/Ajax';
import _, { initial } from 'underscore';
import Backbone from 'backbone';
import html from '../../templates/edit_report_saved_view/preset_view.template?raw';

type ReportTemplate = {
    id: number;
    name: string;
    report_id: number;
    description: string;
};

interface Options extends Backbone.ViewOptions {
    report_id: number;
    editView: any;
}

export default class ContactItemView extends Backbone.View {
    options: Options;
    static events: Backbone.EventsHash = {
        'change .uiSelect input': 'change',
        'click #deletePreset': 'delete',
    };
    constructor(options?: Options) {
        options.events = ContactItemView.events;
        super(options);
        // this.options = options;
        // this.view = this;
        this.options = options;
        // this.events = <any>{ 'change .uiSelect input': this.change };
        this.render();
    }
    render(): this {
        const view = this;
        view.$el.spinner('on', { view });
        Ajax.getJson('reportTemplate/getTemplates?report_id=' + view.options.report_id).then((data: ReportTemplate[]) => {
            view.$el.html(_.template(html)({ $, property: 'view.options.property' }));
            view.renderElements(data);
        });
        return this;
    }
    renderElements(data: ReportTemplate[]) {
        const view = this;
        if (data.length > 0) {
            view.$('select').append(_.make('option', {}, 'keine Auswahl'));
            _.each(data, (item) => {
                view.$('select').append(_.make('option', { value: item.id }, item.name));
            });
        }
        view.$('select').uiselectfield('init', { mark: false });
    }

    delete(e) {
        const view = this;
        const preselected = $('#presetSelector').find('.hiddenInputText').val();
        if (preselected) {
            new Ajax().delete('reportTemplate/deleteTemplate?template_id=' + preselected).then(() => {
                view.render();
            });
        }
    }

    change(evt, val) {
        var selected = this.$('.uiSelect input').val();
        var view = this;
        this.$('.hiddenInputText').val(selected);
        Ajax.getJson('reportTemplate/getParameters?template_id=' + selected).then((data) => {
            let arr = {};
            if (data.length > 0) {
                arr = data.reduce((acc, item) => {
                    acc[item.name] = item.avalue;
                    return acc;
                }, {});
            }
            view.options.editView.setDefaultValues(0, arr);
        });
    }
}
